<template>
    <div class="p-0 lg:px-6 lg:pb-5 xl:px-10 xl:pb-8 md:pt-6 lg:pt-5 xl:pt-8">
        <div class="flex items-center md:absolute md:top md:right-0 md:mr-0 lg:mr-6 xl:mr-10 md:-mt-20 lg:-mt-22 xl:-mt-24 border-b border-gray-400 md:border-none py-3 md:py-0">
            <i class="fa fa-search mr-3 text-gray-500"></i>

            <input-text
                class="w-full md:w-64 lg:w-72 xl:w-80"
                input_class="h-10 lg:h-auto w-full"
                label_class="text-xs text-gray-600 uppercase tracking-widest inline-block leading-snug font-semibold"
                :placeholder="$t('Broker Name')"
                v-model="broker_filter"
            />
        </div>

        <div v-for="broker in filtered_brokers"
            class="flex flex-col md:flex-row items-start border border-gray-400 p-4 md:p-6 lg:p-8 -mt-px"
            :class="{ 'hover:bg-blue-100': properties_by_broker[broker.id] }"
            @click="showSharedProperties(broker)"
        >
            <div class="w-full md:w-1/3 flex-none pr-4 pb-4">
                <div class="font-semibold text-lg md:text-xl leading-tight">
                    {{ broker.name }}
                </div>

                <div v-if="properties_by_broker[broker.id]"
                    class="text-base text-gray-600"
                >
                    {{ properties_by_broker[broker.id].length }} {{ properties_by_broker[broker.id].length == 1 ? $t('property') : $t('properties') }}
                </div>

                <div v-else class="text-base text-gray-600">
                    {{ $t('No properties') }}
                </div>

                <div v-if="broker.team_message" class="mt-2" @click.stop>
                    <team-message-button
                        :options="broker.team_message"
                        variant="small"
                    />
                </div>
            </div>

            <div v-if="properties_by_broker[broker.id]"
                class="w-full md:w-2/3"
            >
                <dashboard-status-shared
                    :properties="properties_by_broker[broker.id]"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DashboardStatusShared from './dashboard-status-shared.vue';
import { groupBy } from 'lodash';

export default {
    components: {
        DashboardStatusShared,
    },

    props: {
        properties: { default: () => [] },
        route: {},
        detail_route: {},
        read_only: { default: true },
        shared_brokers: {},
    },

    data() {
        return {
            broker_filter: null,
        }
    },

    computed: {
        properties_by_broker() {
            return groupBy(this.properties, 'broker.id');
        },
        filtered_brokers() {
            return this.broker_filter
                ? this.shared_brokers.filter(broker => broker.name.toLowerCase()
                    .includes(this.broker_filter.toLowerCase())
                )
                : this.shared_brokers;
        },
    },

    methods: {
        showSharedProperties(broker) {
            if (this.properties_by_broker[broker.id]) {
                window.location.href = "/broker/dashboard/shared/" + broker.id;
            }
        },
    },
}
</script>
